export function getCookieValue(a) {
  var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}

export function PaginationModule () {
  return {
    changePage (type, currentPage, totalPages) {
      let newPage;
      if (type === 'minus') newPage = currentPage - 1;
      if (type === 'plus') newPage = currentPage + 1;
      if (newPage < 1) return false;
      if (newPage > totalPages) return false;
      return newPage;
    }
  }
}